import { CodeBlock, Tabs, TabsPanel } from '@customerio/pluma-components/react';
import { formatBodyJson, formatBodyProperties } from '../utils/message-json';

const INBOX_TABS = [
  { value: 'message', text: 'Message' },
  { value: 'json', text: 'JSON' },
];

type InboxMessagePreviewProps = { body: string };

/**
 * Inbox delivery preview — Message (the payload's `properties`) and JSON (the
 * full payload) tabs, each a formatted-JSON code block, matching the Ember inbox
 * preview which renders both tabs through the JSON formatter.
 */
export function InboxMessagePreview({ body }: InboxMessagePreviewProps) {
  return (
    <Tabs tabs={INBOX_TABS} isBorderless data-test-delivery-preview-inbox>
      <TabsPanel value="message" p="200" data-test-inbox-message-tab>
        <CodeBlock className="fs-mask" code={formatBodyProperties(body)} language="json" withLineNumbers />
      </TabsPanel>
      <TabsPanel value="json" p="200" data-test-inbox-json-tab>
        <CodeBlock className="fs-mask" code={formatBodyJson(body)} language="json" withLineNumbers />
      </TabsPanel>
    </Tabs>
  );
}
